import React, { useState } from 'react';
import {
  countryOptions,
  extractCountryCode,
  validatePhoneNumber
} from '../../utils/phoneUtils';
import './AddMemberModal.css';

const capitalizeFirstLetter = str => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const AddMemberModal = ({ onClose, onAdd, roleOptions }) => {
  const [name, setName] = useState('');
  const [countryLabel, setCountryLabel] = useState(countryOptions[0].label);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const phoneErrMsg = validatePhoneNumber(countryLabel, phone);
  const isPhoneValid = phoneErrMsg === '' && phone.trim();

  const handleAddClick = () => {
    let hasError = false;
    if (!name.trim()) hasError = true;

    if (!phone.trim()) {
      setPhoneError('Phone is required');
      hasError = true;
    } else if (phoneErrMsg) {
      setPhoneError(phoneErrMsg);
      hasError = true;
    } else {
      setPhoneError('');
    }

    if (!selectedRole) hasError = true;
    if (hasError) return;

    const digits = phone.replace(/\D/g, '');
    const cc = extractCountryCode(countryLabel);
    const fullPhone = `${cc}${digits}`;
    const status = isActive ? 'active' : 'inactive';

    onAdd(name.trim(), fullPhone, selectedRole, status);
    onClose();
  };

  return (
    <div className="add-member-backdrop">
      <div className="add-member-modal">
        <h2>Add Member</h2>

        <div className="add-member-input-group">
          <label className="add-member-label">Name</label>
          <input
            type="text"
            placeholder="Enter member name"
            value={name}
            onChange={e => setName(e.target.value)}
            className="add-member-input"
          />
        </div>

        <div className="add-member-input-group">
          <label className="add-member-label">Country/Region</label>
          <select
            className="add-member-input"
            value={countryLabel}
            onChange={e => setCountryLabel(e.target.value)}
          >
            {countryOptions.map(o => (
              <option key={o.code + o.label} value={o.label}>
                {o.label}
              </option>
            ))}
          </select>
        </div>

        <div className="add-member-input-group">
          <label className="add-member-label">Phone</label>
          <input
            type="tel"
            placeholder={`Enter ${
              countryOptions.find(o => o.label === countryLabel).length
            } digits`}
            value={phone}
            onChange={e => {
              setPhone(e.target.value);
              setPhoneError('');
            }}
            className={`add-member-input ${phoneError ? 'error' : ''}`}
          />
          {phoneError && (
            <div className="error-message">{phoneError}</div>
          )}
        </div>

        <div className="add-member-input-group">
          <label className="add-member-label">Role</label>
          <div
            className="role-dropdown-trigger"
            onClick={() => setIsRoleDropdownOpen(open => !open)}
          >
            {selectedRole ? capitalizeFirstLetter(selectedRole) : 'Select Role'}
            <span className="dropdown-arrow">▼</span>
          </div>
          {isRoleDropdownOpen && (
            <div className="role-dropdown-options">
              {roleOptions.map(option => (
                <div
                  key={option}
                  className="role-option"
                  onClick={() => {
                    setSelectedRole(option.toLowerCase());
                    setIsRoleDropdownOpen(false);
                  }}
                >
                  {capitalizeFirstLetter(option)}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="add-member-input-group">
          <label className="add-member-checkbox-label">
            <input
              type="checkbox"
              checked={isActive}
              onChange={e => setIsActive(e.target.checked)}
              className="add-member-checkbox"
            />
            Active
          </label>
        </div>

        <div className="add-member-actions">
          <button onClick={onClose} className="add-member-button cancel">
            Cancel
          </button>
          <button onClick={handleAddClick} className="add-member-button add">
            Add Member
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddMemberModal;
